<template>
  <div class="app-navbar-shell">
    <VaNavbar class="app-layout-navbar">
      <!-- LEFT SLOT -->
      <template #left>
        <div v-if="!isMobile" class="navbar-chat">
          <Chat />
        </div>
        <div v-else class="navbar-logo" role="link" @click="goHome">
          <img src="/logo_horizontal_blanco.png" alt="SpendFit" class="navbar-logo__image" />
        </div>
      </template>

      <!-- CENTER SLOT -->
      <template #center />

      <!-- RIGHT SLOT -->
      <template #right>
        <div v-if="isMobile" class="navbar-mobile-tools">
          <div class="navbar-mobile-tools__space">
            <WorkspaceSwitcher compact />
          </div>
          <div class="navbar-mobile-tools__slot">
            <NotificationDropdown />
          </div>
          <div class="navbar-mobile-tools__slot">
            <AppNavbarActions :is-mobile="true" />
          </div>
        </div>
        <div v-else class="navbar-right">
          <AppNavbarActions :is-mobile="false" />
        </div>
      </template>
    </VaNavbar>
  </div>
</template>

<script setup lang="ts">
import { defineProps } from 'vue'
import { useRouter } from 'vue-router'
import AppNavbarActions from './components/AppNavbarActions.vue'
import Chat from '../../pages/chat/Chat.vue'
import NotificationDropdown from './components/dropdowns/NotificationDropdown.vue'
import WorkspaceSwitcher from '../sidebar/components/WorkspaceSwitcher.vue'

defineProps({
  isMobile: { type: Boolean, default: false },
})

const router = useRouter()

function goHome() {
  router.push({ name: 'dashboard' })
}
</script>

<style scoped>
.app-navbar-shell {
  position: relative;
  z-index: 10;
  flex: 0 0 auto;
  background: #fff;
  border-bottom: 1px solid #d5dbe3;
}

.app-layout-navbar {
  background-color: var(--va-primary);
  color: white;
}

.app-navbar__actions {
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;
}

.app-layout-navbar :deep(.va-navbar__left),
.app-layout-navbar :deep(.va-navbar__right) {
  min-width: 0;
}

.navbar-chat {
  width: 100%;
  min-width: 0;
}

.navbar-right {
  display: flex;
  justify-content: flex-end;
  width: 100%;
}

.navbar-mobile-tools {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
  min-width: 0;
  gap: 0;
}

.navbar-mobile-tools__space {
  flex: 1 1 auto;
  min-width: 0;
  display: flex;
  align-items: center;
  margin-right: 0.35rem;
}

.navbar-mobile-tools__slot {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
}

.navbar-logo {
  position: relative;
  cursor: pointer;
  width: calc(2.5rem * 1229 / 348);
  max-width: 100%;
  height: 2.5rem;
  margin: 0;
  aspect-ratio: 1229 / 348;
  overflow: hidden;
}

.navbar-logo__image {
  position: absolute;
  display: block;
  max-width: none;
  width: 124.98%;
  height: 294.25%;
  left: -13.75%;
  top: -90.52%;
}

@media screen and (min-width: 821px) {
  .app-layout-navbar {
    grid-template-columns: minmax(0, 1fr) auto;
    grid-template-areas: 'left right';
    column-gap: 0.75rem;
  }

  .app-layout-navbar :deep(.va-navbar__center) {
    display: none;
  }

  .app-layout-navbar :deep(.va-navbar__left) {
    width: 100%;
    min-width: 0;
  }
}

@media screen and (max-width: 820px) {
  .app-layout-navbar {
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
    grid-template-areas: 'left right';
  }

  .app-layout-navbar :deep(.va-navbar__left) {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
  }

  .app-layout-navbar :deep(.va-navbar__center) {
    display: none;
  }
}
</style>
